var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ag-grid__overlay-form-box" }, [
    _c("div", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "TRANSCRIBE_CALLS",
          expression: "'TRANSCRIBE_CALLS'"
        }
      ],
      staticClass: "ag-grid__overlay-form-box-title"
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-horizontal p-15" },
      [
        !_vm.selectedCalls.length
          ? [
              _c(
                "div",
                { staticClass: "f-s-16 p-l-15 col-md-offset-3 m-b-10" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("TRANSCRIBE_CALLS_NUMBER", {
                          adjustmentCount: _vm.adjustmentCount
                        })
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "f-s-12 p-l-15 col-md-offset-3 m-b-10" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("TRANSCRIBE_CALLS_MESSAGE", {
                          adjustmentCount: _vm.adjustmentCount
                        })
                      ) +
                      "\n      "
                  )
                ]
              )
            ]
          : [
              _c(
                "div",
                { staticClass: "p-l-15 m-b-10 col-md-offset-3" },
                [
                  _c("BulkCallDetails", {
                    key: _vm.bulkCallReviewKey,
                    attrs: { "selected-calls": _vm.selectedCalls },
                    on: {
                      unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "f-s-12 p-l-15 col-md-offset-3 m-b-10" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("TRANSCRIBE_SELECTED_CALLS_MESSAGE")) +
                      "\n      "
                  )
                ]
              )
            ],
        _vm._v(" "),
        _c(
          "div",
          [
            _c("i18n", {
              staticClass: "f-s-12 p-l-15 col-md-offset-3 m-b-10",
              attrs: { path: "TRANSCRIBE_CALLS_FEE_MESSAGE", tag: "div" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.$t("TRANSCRIBE_CALLS_FEE_MESSAGE_LABEL"))
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "checkbox f-s-12 p-l-15 col-md-offset-3 col-sm-offset-2 m-b-5"
              },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmTranscription,
                        expression: "confirmTranscription"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.confirmTranscription)
                        ? _vm._i(_vm.confirmTranscription, null) > -1
                        : _vm.confirmTranscription
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.confirmTranscription,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.confirmTranscription = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.confirmTranscription = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.confirmTranscription = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TRANSCRIBE_CALLS_ATTEST",
                        expression: "'TRANSCRIBE_CALLS_ATTEST'"
                      }
                    ],
                    staticClass: "p-t-2"
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "col-sm-offset-2 col-md-offset-3 col-md-7" },
                [
                  _c(
                    "PrimaryButton",
                    {
                      attrs: {
                        size: "sm",
                        disabled: !_vm.confirmTranscription || _vm.showLoader,
                        "show-loader-on-form": _vm.showLoader
                      },
                      on: { click: _vm.callTranscriptionSubmit }
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "TRANSCRIBE_SEND_BTN",
                            expression: "'TRANSCRIBE_SEND_BTN'"
                          }
                        ]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CANCEL",
                        expression: "'CANCEL'"
                      }
                    ],
                    staticClass: "btn btn-sm btn-danger m-l-15",
                    attrs: { type: "button" },
                    on: { click: _vm.hideBulkForm }
                  })
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }